module.exports = __webpack_public_path__ + "static/media/12_Rockefeller Center - New York City.195fd50b.jpg";